/* Novelle Necklace builder (formerly Luna Luxe): 1 to 7 letter pendants that spell a name, built from the Fable letter pendants.
   Letter count is a dropdown with prices that drives the theme's hidden "Personalization" buttons (and so the variant/price).
   Once a count is chosen, a box takes the name: capital letters A to Z only, as many as the count. When every letter is in,
   a "Show Preview" button appears next to the box; it puts the design in the photo gallery as its own slide and glides up to it.
   After that the design follows every change (name, count, finish) live.
   The preview is drawn in the shopper's browser and is never saved as product media, so product feeds, catalogs and ads never see it.
   The preview is the Novelle chain photo exactly as photographed (gold, or recolored silver), with the letters placed on
   it like the 4-letter reference photo: evenly spaced along the chain, centred, a letter in the middle for odd counts,
   each letter's top corners on the chain. The chain is never bent; it stops between each letter's two jump rings.
   Line-item properties keep exactly the names the personalizer app sent: "Enter Five Letters" (etc.) and _pplr_customization_id. */
(function () {
  'use strict';
  var root = document.querySelector('[data-luna]');
  if (!root || root.__luna) return;
  root.__luna = true;
  var CFG = JSON.parse(root.getAttribute('data-cfg'));
  var GEO = {"size":1254,"ds":4.0,"p":[98.5,6.0,98.8,10.0,99.0,14.0,99.2,18.0,99.8,21.9,100.7,25.8,101.9,29.6,103.0,33.5,103.9,37.4,104.5,41.3,105.2,45.3,105.8,49.2,106.6,53.1,107.7,57.0,109.0,60.8,110.2,64.6,111.2,68.4,112.1,72.4,112.7,76.3,113.5,80.2,114.3,84.1,115.2,88.0,116.3,91.9,117.5,95.7,118.7,99.5,119.7,103.4,120.4,107.3,121.2,111.2,122.1,115.2,122.9,119.1,123.8,123.0,125.0,126.8,126.2,130.6,127.3,134.4,128.3,138.3,129.1,142.2,130.0,146.1,130.9,150.0,131.8,153.9,132.8,157.8,133.9,161.6,135.0,165.5,136.0,169.4,136.9,173.3,137.8,177.2,138.6,181.1,139.6,185.0,140.5,188.8,141.6,192.7,142.7,196.5,143.8,200.4,144.8,204.2,145.7,208.1,146.6,212.0,147.5,215.9,148.5,219.8,149.5,223.7,150.5,227.6,151.6,231.4,152.5,235.3,153.4,239.2,154.3,243.1,155.2,247.0,156.3,250.8,157.3,254.7,158.3,258.6,159.4,262.4,160.4,266.3,161.4,270.2,162.3,274.1,163.2,278.0,164.2,281.8,165.2,285.7,166.3,289.6,167.3,293.4,168.3,297.3,169.2,301.2,170.1,305.1,171.1,309.0,172.1,312.8,173.2,316.7,174.3,320.6,175.3,324.4,176.3,328.3,177.4,332.1,178.4,336.0,179.4,339.9,180.4,343.7,181.4,347.6,182.5,351.5,183.6,355.3,184.6,359.2,185.7,363.0,186.7,366.9,187.7,370.8,188.8,374.6,189.9,378.5,191.0,382.3,192.2,386.1,193.3,390.0,194.4,393.8,195.5,397.7,196.6,401.5,197.7,405.4,198.9,409.2,200.0,413.0,201.2,416.8,202.4,420.6,203.5,424.5,204.7,428.3,205.8,432.2,206.9,436.0,208.1,439.8,209.3,443.6,210.5,447.4,211.8,451.2,213.1,455.0,214.2,458.9,215.4,462.7,216.5,466.5,217.8,470.3,219.1,474.1,220.4,477.9,221.8,481.6,223.2,485.4,224.5,489.2,225.7,493.0,226.9,496.8,228.2,500.6,229.6,504.3,231.0,508.1,232.4,511.8,233.9,515.5,235.3,519.2,236.6,523.0,237.8,526.9,239.0,530.7,240.4,534.4,242.0,538.1,243.4,541.8,244.9,545.5,246.5,549.2,248.0,552.9,249.4,556.7,250.7,560.4,252.0,564.2,253.6,567.9,255.2,571.5,256.8,575.2,258.5,578.9,260.2,582.5,261.8,586.1,263.2,589.9,264.5,593.7,265.9,597.4,267.5,601.1,269.2,604.7,270.9,608.3,272.6,611.9,274.4,615.5,276.1,619.1,277.7,622.8,279.1,626.6,280.5,630.3,282.2,633.9,284.0,637.5,285.9,641.0,287.7,644.6,289.6,648.1,291.4,651.7,293.1,655.3,294.5,659.0,296.0,662.7,297.7,666.4,299.6,669.9,301.5,673.4,303.5,676.9,305.5,680.3,307.4,683.8,309.2,687.4,310.9,691.1,312.4,694.7,314.2,698.3,316.0,701.9,318.1,705.3,320.2,708.7,322.3,712.1,324.3,715.6,326.2,719.1,328.0,722.7,329.7,726.3,331.5,729.9,333.4,733.4,335.4,736.8,337.7,740.1,339.9,743.4,342.1,746.8,344.1,750.3,346.1,753.8,348.0,757.3,349.9,760.8,352.0,764.2,354.1,767.6,356.5,770.8,358.9,774.0,361.2,777.2,363.5,780.6,365.6,783.9,367.8,787.3,370.0,790.6,372.2,794.0,374.6,797.2,377.1,800.3,379.7,803.3,382.2,806.4,384.6,809.6,387.0,812.8,389.5,815.9,392.0,819.1,394.5,822.2,397.1,825.2,399.9,828.1,402.8,830.9,405.5,833.8,408.2,836.7,410.9,839.7,413.6,842.6,416.4,845.5,419.1,848.4,422.1,851.1,425.2,853.7,428.2,856.2,431.3,858.9,434.3,861.5,437.2,864.2,440.2,866.8,443.3,869.4,446.3,872.0,449.5,874.4,452.8,876.7,456.2,878.8,459.5,881.0,462.8,883.3,466.1,885.5,469.4,887.8,472.7,890.1,476.1,892.2,479.5,894.3,483.0,896.2,486.6,898.0,490.2,899.8,493.8,901.6,497.4,903.3,500.9,905.1,504.5,906.9,508.1,908.7,511.8,910.3,515.5,911.8,519.2,913.1,523.0,914.4,526.8,915.7,530.6,916.9,534.4,918.2,538.2,919.5,542.0,920.7,545.8,921.8,549.7,922.9,553.6,923.8,557.5,924.6,561.5,925.3,565.4,926.0,569.4,926.6,573.3,927.2,577.2,927.9,581.2,928.5,585.2,929.0,589.1,929.4,593.1,929.7,597.1,929.8,601.1,929.9,605.1,929.9,609.1,929.9,613.1,929.9,617.1,929.8,621.1,929.6,625.1,929.5,629.1,929.2,633.1,928.7,637.1,928.2,641.0,927.5,644.9,926.8,648.9,926.0,652.8,925.3,656.7,924.5,660.6,923.8,664.5,922.9,668.4,921.9,672.3,920.8,676.1,919.7,679.9,918.4,683.7,917.0,687.4,915.7,691.2,914.3,694.9,913.0,698.7,911.6,702.4,910.2,706.1,908.6,709.8,907.0,713.3,905.2,716.9,903.3,720.4,901.4,723.9,899.5,727.4,897.6,730.9,895.7,734.5,893.8,737.9,891.8,741.4,889.8,744.7,887.6,748.0,885.3,751.2,882.9,754.4,880.5,757.7,878.2,760.9,875.9,764.2,873.6,767.5,871.3,770.7,869.0,773.9,866.5,776.9,863.9,779.9,861.2,782.8,858.5,785.8,855.8,788.7,853.0,791.5,850.2,794.5,847.5,797.5,844.9,800.4,842.1,803.3,839.3,806.1,836.5,808.9,833.7,811.6,830.8,814.2,827.7,816.7,824.6,819.3,821.6,822.1,818.7,824.9,815.8,827.5,812.8,830.2,809.8,832.9,806.9,835.4,803.7,837.7,800.5,840.0,797.2,842.3,793.9,844.5,790.6,846.8,787.3,849.2,784.1,851.7,781.0,854.0,777.8,856.3,774.4,858.3,771.0,860.4,767.6,862.5,764.2,864.6,760.7,866.6,757.3,868.8,754.0,871.0,750.6,873.1,747.2,875.2,743.8,877.3,740.4,879.4,737.0,881.4,733.5,883.3,730.0,885.2,726.5,887.3,723.1,889.4,719.7,891.4,716.2,893.3,712.7,895.0,709.1,896.8,705.5,898.7,702.0,900.7,698.5,902.5,695.0,904.4,691.4,906.3,687.9,908.2,684.4,909.9,680.8,911.6,677.2,913.4,673.6,915.1,670.0,917.0,666.4,918.9,662.9,920.9,659.4,922.7,655.9,924.4,652.2,926.0,648.6,927.6,644.9,929.2,641.2,930.9,637.7,932.9,634.2,934.7,630.6,936.4,627.0,938.0,623.3,939.4,619.6,940.9,615.9,942.4,612.2,944.2,608.6,945.9,605.0,947.6,601.4,949.3,597.7,950.8,594.0,952.3,590.3,953.6,586.5,955.1,582.8,956.9,579.2,958.6,575.6,960.2,572.0,961.9,568.3,963.5,564.7,965.0,560.9,966.3,557.2,967.6,553.4,969.2,549.7,970.9,546.1,972.5,542.4,974.1,538.8,975.7,535.1,977.2,531.4,978.5,527.6,979.8,523.8,981.2,520.1,982.9,516.4,984.4,512.8,985.9,509.0,987.4,505.3,988.8,501.6,990.2,497.8,991.4,494.0,992.7,490.2,994.2,486.5,995.7,482.8,997.2,479.1,998.6,475.4,1000.0,471.6,1001.3,467.9,1002.7,464.1,1004.0,460.3,1005.4,456.6,1006.9,452.9,1008.3,449.1,1009.7,445.4,1011.0,441.6,1012.4,437.8,1013.7,434.1,1014.9,430.2,1016.1,426.4,1017.6,422.7,1018.9,418.9,1020.3,415.2,1021.6,411.4,1022.8,407.6,1024.0,403.8,1025.1,399.9,1026.4,396.2,1027.8,392.4,1029.1,388.6,1030.4,384.8,1031.6,381.0,1032.9,377.2,1034.3,373.5,1035.5,369.7,1036.8,365.9,1038.2,362.1,1039.5,358.4,1040.7,354.6,1042.0,350.8,1043.1,346.9,1044.3,343.1,1045.5,339.3,1046.8,335.5,1048.0,331.7,1049.3,327.9,1050.4,324.1,1051.6,320.3,1052.9,316.4,1054.0,312.6,1055.2,308.8,1056.4,305.0,1057.6,301.2,1058.8,297.3,1060.0,293.5,1061.1,289.7,1062.3,285.9,1063.4,282.0,1064.6,278.2,1065.7,274.4,1066.8,270.5,1068.0,266.7,1069.2,262.9,1070.2,259.0,1071.3,255.2,1072.5,251.3,1073.7,247.5,1074.9,243.7,1076.1,239.9,1077.2,236.1,1078.3,232.2,1079.5,228.4,1080.8,224.6,1082.0,220.8,1083.0,216.9,1084.2,213.1,1085.3,209.3,1086.2,205.4,1087.3,201.5,1088.4,197.7,1089.6,193.9,1090.7,190.0,1091.7,186.1,1092.8,182.3,1094.0,178.5,1095.0,174.6,1096.0,170.7,1097.1,166.9,1098.3,163.1,1099.6,159.3,1100.7,155.5,1101.7,151.6,1102.8,147.8,1103.9,143.9,1104.8,140.0,1105.8,136.1,1106.9,132.3,1108.1,128.5,1109.3,124.6,1110.2,120.8,1111.2,116.9,1112.3,113.0,1113.2,109.1,1114.1,105.2,1115.2,101.4,1116.3,97.6,1117.5,93.7,1118.6,89.9,1119.7,86.0,1120.7,82.2,1121.7,78.3,1122.6,74.4,1123.5,70.5,1124.7,66.7,1125.9,62.9,1127.1,59.1,1128.2,55.2,1129.3,51.4,1130.2,47.5,1131.1,43.6,1132.1,39.7,1133.1,35.8,1134.3,32.0,1135.5,28.2,1136.5,24.3,1136.9,20.4,1137.0,16.4,1137.0,12.4,1137.0,8.4],"mid":1123.0,"cs":0.86329,"cell":[152,105],"G":[[29,121,9,99],[36,117,9,100],[39,114,8,99],[36,121,8,100],[38,113,9,99],[38,115,9,99],[35,116,9,98],[36,116,9,99],[41,109,9,100],[39,110,9,101],[36,116,8,99],[39,115,8,100],[31,119,8,98],[36,117,8,98],[33,119,8,100],[36,117,9,99],[36,115,9,104],[36,118,9,99],[37,115,9,100],[33,117,7,99],[36,116,9,100],[35,117,8,100],[31,121,9,98],[35,115,9,97],[36,116,9,99],[36,116,9,100]],"sp":205,"top":9,"R":[[50,98],[46,106],[48,102],[45,105],[47,103],[47,105],[47,104],[45,106],[50,99],[48,100],[46,106],[49,94],[41,110],[45,107],[46,106],[46,105],[46,106],[46,105],[46,106],[44,106],[45,106],[44,106],[42,109],[45,106],[46,106],[46,106]]};   // p: the chain's centre line (every ds px along it); mid: its low point; G: each letter's box in the sprite; sp: spacing
  var SIZE = GEO.size;
  var OPT = CFG.opt;   // data-handle of the theme's letter-count option row

  var S = { n: 0, name: '', shown: false };
  var q = function (s) { return root.querySelector(s); };
  var sel = q('[data-luna-count]'), step2 = q('[data-luna-step2]'), inp = q('[data-luna-name]'), btn = q('[data-luna-show]'),
      labEl = q('[data-luna-namelab]'), metaEl = q('[data-luna-meta]'), hintEl = q('[data-luna-hint]'), errEl = q('[data-luna-err]');

  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function finishValue() { var r = document.querySelector('fieldset[data-handle="finish"] input:checked'); return r ? r.value : CFG.finish; }
  function fin() { return /silver/i.test(finishValue()) ? 'silver' : 'gold'; }
  function countValue(n) { return CFG.counts[n - 1]; }                 // "Five Letters"
  function complete() { return S.n > 0 && S.name.length === S.n; }
  function clean(v) { return String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z]/g, ''); }

  /* ---------- letter count dropdown (price per option follows the chosen finish) ---------- */
  function drawCount() {
    var f = finishValue();
    sel.innerHTML = '';
    var ph = el('option', null, 'Select number of letters'); ph.value = ''; ph.disabled = true; if (!S.n) ph.selected = true;
    sel.appendChild(ph);
    CFG.counts.forEach(function (v, k) {
      var n = k + 1, p = CFG.prices[f + '|' + v], o = el('option');
      o.value = n; o.textContent = n + (n === 1 ? ' letter' : ' letters') + (p ? '  —  ' + p : '');
      if (n === S.n) o.selected = true;
      sel.appendChild(o);
    });
  }
  function syncTheme(n) {
    var v = countValue(n); if (!v) return;
    var r = document.querySelector('fieldset[data-handle="' + OPT + '"] input[value="' + v.replace(/"/g, '\\"') + '"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.dispatchEvent(new Event('input', { bubbles: true })); }
  }

  /* ---------- the name box ---------- */
  var hintT;
  function hint(msg) {
    clearTimeout(hintT);
    hintEl.textContent = msg || ''; hintEl.hidden = !msg;
    if (msg) hintT = setTimeout(function () { hintEl.hidden = true; }, 4000);
  }
  function drawName() {
    var n = S.n, k = S.name.length;
    step2.hidden = !n;
    root.classList.toggle('is-complete', complete());
    if (!n) return;
    labEl.textContent = n === 1 ? 'Type your initial' : 'Type your name';
    inp.maxLength = n;
    inp.placeholder = n === 1 ? 'Type 1 letter' : 'Type ' + n + ' letters';
    inp.setAttribute('aria-label', n === 1 ? 'Your initial, 1 letter' : 'Your name, ' + n + ' letters');
    if (inp.value !== S.name) inp.value = S.name;
    metaEl.textContent = k === n ? (n === 1 ? '1 of 1 letter ✓' : 'All ' + n + ' letters ✓') : k + ' of ' + n + (n === 1 ? ' letter' : ' letters');
    btn.hidden = !complete();
    btn.tabIndex = complete() ? 0 : -1;
  }
  inp.addEventListener('input', function () {
    var raw = inp.value, pos = inp.selectionStart == null ? raw.length : inp.selectionStart;
    var all = clean(raw), v = all.slice(0, S.n);
    if (/[^A-Za-zÀ-ɏ]/.test(raw)) hint('Letters A to Z only.');
    else if (all.length > S.n) hint('Your necklace has ' + S.n + (S.n === 1 ? ' letter' : ' letters') + '. For a longer name, choose more letters above.');
    if (v !== raw) {
      var at = Math.min(clean(raw.slice(0, pos)).length, v.length);
      inp.value = v;
      try { inp.setSelectionRange(at, at); } catch (e) {}
    }
    S.name = v;
    errEl.hidden = true; root.classList.remove('is-invalid');
    drawName(); syncProps();
    if (S.shown) render(false);
  });
  inp.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); if (complete()) preview(); }
  });
  btn.addEventListener('click', function (e) { e.preventDefault(); preview(); });

  /* the personalizer app still loads its own "Enter ... Letters" box on this product (the live template uses it until this
     page is published). On this page the builder replaces it: its box is removed, so it can't add a second, empty
     "Enter ... Letters" property to the order or hold back Add to bag waiting for its own box to be filled */
  function unzep() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-personalizer'), function (e) { e.parentNode.removeChild(e); });
    Array.prototype.forEach.call(document.querySelectorAll('input[name^="properties[Enter "], input[name="properties[_pplr_customization_id]"]'), function (i) {
      if (!i.closest('[data-luna-props]')) i.parentNode.removeChild(i);
    });
  }

  /* ---------- line-item properties inside the real product form ---------- */
  function productForm() {
    var ref = document.querySelector('fieldset[data-handle="finish"] input[type="radio"], fieldset[data-handle="' + OPT + '"] input[type="radio"]');
    var id = ref && ref.getAttribute('form');
    return (id && document.getElementById(id)) || document.querySelector('form[action*="/cart/add"][id^="product-form-"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function syncProps() {
    var form = productForm(); if (!form) return;
    var box = form.querySelector('[data-luna-props]');
    if (!box) { box = document.createElement('div'); box.setAttribute('data-luna-props', ''); box.hidden = true; form.appendChild(box); }
    var rows = [];
    if (S.n) { rows.push(['Enter ' + countValue(S.n), S.name]); rows.push(['_pplr_customization_id', '']); }
    var sig = JSON.stringify(rows);
    if (box.getAttribute('data-sig') === sig) return;
    box.setAttribute('data-sig', sig);
    box.innerHTML = '';
    rows.forEach(function (r) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'properties[' + r[0] + ']'; h.value = r[1];
      box.appendChild(h);
    });
  }

  /* ---------- preview: the letters hang on the Luna chain photo ---------- */
  var imgs = {};
  function load(u) {
    if (!imgs[u]) imgs[u] = new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { res(im); }; im.onerror = function () { delete imgs[u]; rej(new Error(u)); }; im.src = u;
    });
    return imgs[u];
  }
  /* a point on the chain, t = distance along it (px on the chain photo) */
  function P(t) {
    var p = GEO.p, n = p.length / 2, x = t / GEO.ds;
    if (x < 0) x = 0; if (x > n - 1) x = n - 1;
    var i = Math.min(Math.floor(x), n - 2), f = x - i;
    return [p[2 * i] + f * (p[2 * i + 2] - p[2 * i]), p[2 * i + 1] + f * (p[2 * i + 3] - p[2 * i + 1])];
  }
  /* where each letter sits: evenly spaced along the chain (GEO.sp apart, as in the 4-letter reference photo), centred on
     the low point, so odd counts have a letter in the middle. Each letter's two top corners sit on the chain, so it
     follows the chain's direction there. */
  function layout(n, name) {
    var out = [], cs = GEO.cs;
    for (var k = 0; k < n; k++) {
      var mid = GEO.mid + (k - (n - 1) / 2) * GEO.sp, ch = name.charCodeAt(k) - 65;
      var o = { k: k, mid: mid, i: ch >= 0 && ch < 26 ? ch : -1 };
      var w = o.i < 0 ? 66 : (GEO.G[o.i][1] - GEO.G[o.i][0]) * cs, sl = mid - w / 2, sr = mid + w / 2, a, b;
      for (var j = 0; j < 4; j++) { a = P(sl); b = P(sr); var e = (w - Math.hypot(b[0] - a[0], b[1] - a[1])) / 2; sl -= e; sr += e; }
      o.a = P(sl); o.b = P(sr); o.ang = Math.atan2(o.b[1] - o.a[1], o.b[0] - o.a[0]);
      /* the stretch of chain between the letter's two jump rings (GEO.R: the rings' x in the sprite) */
      if (o.i >= 0) { var R = GEO.R[o.i], G0 = GEO.G[o.i][0]; o.r0 = sl + (R[0] - G0) * cs / w * (sr - sl); o.r1 = sl + (R[1] - G0) * cs / w * (sr - sl); }
      out.push(o);
    }
    return out;
  }
  /* a letter still to type: a numbered dotted circle hanging where it will go */
  function placeholder(ctx, o, f) {
    var c = Math.cos(o.ang), s = Math.sin(o.ang), mx = (o.a[0] + o.b[0]) / 2, my = (o.a[1] + o.b[1]) / 2,
        r = 28, cx = mx - s * 36, cy = my + c * 36, ink = f === 'silver' ? 'rgba(105,108,114,.85)' : 'rgba(150,112,52,.9)';
    ctx.save();
    ctx.lineWidth = 2.5; ctx.strokeStyle = ink; ctx.setLineDash([7, 6]);
    ctx.fillStyle = 'rgba(255,255,255,.62)';
    ctx.beginPath(); ctx.arc(cx, cy, r, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    ctx.setLineDash([]);
    ctx.fillStyle = ink; ctx.font = '600 24px "Helvetica Neue", Helvetica, Arial, sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText(String(o.k + 1), cx, cy + 1);
    ctx.restore();
  }
  /* the chain runs into each letter's two jump rings and stops there: between the rings the chain is wiped out with the
     chain-free photo (same backdrop for both metals). The wiped strip follows the chain, with soft edges so nothing shows. */
  var mk;
  function strip(c, t0, t1, hw, dx) {
    var m = Math.max(2, Math.ceil((t1 - t0) / 4) + 1), L = [], Rt = [], j, t, p, a, b, d, nx, ny;
    for (j = 0; j <= m; j++) {
      t = t0 + (t1 - t0) * j / m; p = P(t); a = P(t - 2); b = P(t + 2);
      d = Math.hypot(b[0] - a[0], b[1] - a[1]) || 1; nx = -(b[1] - a[1]) / d; ny = (b[0] - a[0]) / d;
      L.push([p[0] + nx * hw, p[1] + ny * hw]); Rt.push([p[0] - nx * hw, p[1] - ny * hw]);
    }
    L = L.concat(Rt.reverse());
    c.moveTo(L[0][0] - dx, L[0][1]);
    for (j = 1; j < L.length; j++) c.lineTo(L[j][0] - dx, L[j][1]);
    c.closePath();
  }
  function unchain(ctx, plate, g) {
    var todo = g.filter(function (o) { return o.i >= 0; });
    if (!plate || !todo.length) return;
    mk = mk || document.createElement('canvas');
    if (mk.width !== SIZE) { mk.width = SIZE; mk.height = SIZE; }
    var c = mk.getContext('2d'), dx = SIZE * 3;
    c.setTransform(1, 0, 0, 1, 0, 0); c.globalCompositeOperation = 'source-over'; c.clearRect(0, 0, SIZE, SIZE);
    /* drawn off to the side so only its blurred shadow lands on the canvas: a feathered mask in every browser */
    c.save(); c.shadowColor = '#000'; c.shadowBlur = 4; c.shadowOffsetX = dx; c.fillStyle = '#000';
    c.beginPath(); todo.forEach(function (o) { strip(c, o.r0, o.r1, 13, dx); }); c.fill();
    c.restore();
    c.globalCompositeOperation = 'source-in'; c.drawImage(plate, 0, 0, SIZE, SIZE); c.globalCompositeOperation = 'source-over';
    ctx.drawImage(mk, 0, 0);
  }
  function paint(ctx, f, n, name, im) {
    var base = im[0], sheet = im[1], g = layout(n, name), k, o, cs = GEO.cs, cw = GEO.cell[0], chh = GEO.cell[1];
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.drawImage(base, 0, 0, SIZE, SIZE);
    unchain(ctx, im[2], g);
    for (k = 0; k < g.length; k++) {
      o = g[k];
      if (o.i < 0) { placeholder(ctx, o, f); continue; }
      var G = GEO.G[o.i];
      ctx.save();
      /* a soft shadow on the backdrop, like the reference photo */
      ctx.shadowColor = f === 'silver' ? 'rgba(70,64,60,.22)' : 'rgba(110,70,25,.24)';
      ctx.shadowBlur = 10; ctx.shadowOffsetX = 5; ctx.shadowOffsetY = 9;
      /* the letter's top-left corner on the chain, its top edge along the chain, its jump rings on the chain's centre line */
      ctx.translate(o.a[0], o.a[1]); ctx.rotate(o.ang);
      ctx.drawImage(sheet, o.i * cw, 0, cw, chh, -G[0] * cs, -(G[2] + GEO.top) * cs, cw * cs, chh * cs);
      ctx.restore();
    }
    return g;
  }
  /* the part of the picture the letters are in, for the gallery thumbnail */
  function focus(g) {
    var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
    g.forEach(function (o) {
      var c = Math.cos(o.ang), s = Math.sin(o.ang);
      [o.a, o.b, [o.a[0] - s * 85, o.a[1] + c * 85], [o.b[0] - s * 85, o.b[1] + c * 85]].forEach(function (p) {
        x0 = Math.min(x0, p[0]); x1 = Math.max(x1, p[0]); y0 = Math.min(y0, p[1]); y1 = Math.max(y1, p[1]);
      });
    });
    var side = Math.min(SIZE, Math.max(520, x1 - x0 + 120, y1 - y0 + 120)), cx = (x0 + x1) / 2, cy = (y0 + y1) / 2;
    return [Math.max(0, Math.min(SIZE - side, cx - side / 2)), Math.max(0, Math.min(SIZE - side, cy - side / 2)), side];
  }

  var cv = document.createElement('canvas'); cv.width = SIZE; cv.height = SIZE;
  cv.className = 'luna-preview'; cv.setAttribute('role', 'img');

  /* ---------- the design as its own slide in the photo gallery (same as Sora, Versana and Eliora) ----------
     Built in the shopper's browser only. Shoppers can swipe to the photos and back to their design, and the
     thumbnail strip gets a "Your design" thumbnail at the top. */
  var gal = (function () {
    var slide = null, thumb = null, tctx = null;
    function sl() { var s = document.getElementById('Product-Slider'); return s && s.flkty && typeof s.reInit === 'function' ? s : null; }
    function strip() { return document.getElementById('Product-Thumbnails'); }
    function sfx(id) { return (id || '').replace(/^(Slide|Thumb)-/, ''); }
    function make() {
      slide = el('div', 'product-images__slide is-active luna-slide');
      slide.id = 'Slide-luna-design';
      var media = el('div', 'product-single__media luna-slide__media');   // the theme expects this wrapper on every slide
      media.appendChild(cv);
      media.appendChild(el('span', 'luna-slide__tag', 'Your design'));
      slide.appendChild(media);
      thumb = el('div', 'product-thumbnail is-active luna-thumb');
      thumb.id = 'Thumb-luna-design';
      var tc = document.createElement('canvas'); tc.width = tc.height = 200; tctx = tc.getContext('2d');
      thumb.appendChild(tc);
      thumb.appendChild(el('span', 'luna-thumb__tag', 'Your design'));
    }
    function index() {
      var s = sl(); if (!s || !slide) return -1;
      for (var i = 0; i < s.flkty.cells.length; i++) if (s.flkty.cells[i].element === slide) return i;
      return -1;
    }
    /* slide N must match thumbnail N (after a finish change the theme brings that finish's photo forward while its
       thumbnail stays put, so thumbnail clicks would open the wrong photo) */
    function inOrder() {
      var s = sl(), st = strip(); if (!s || !st) return true;
      var th = st.querySelectorAll('.product-thumbnail.is-active'), cells = s.flkty.cells;
      if (th.length !== cells.length) return true;
      for (var i = 0; i < cells.length; i++) if (sfx(cells[i].element.id) !== sfx(th[i].id)) return false;
      return true;
    }
    /* rebuild the theme's slider with the slides in thumbnail order (design first); thumbnails are swapped for clean
       copies because the theme's click handlers remember each photo's old position */
    function rebuild() {
      var s = sl(); if (!s) return false;
      /* the theme may still be gliding to a photo (it does on every count or finish change). A slider that is rebuilt
         mid-glide keeps drawing a couple of photos at their old spots for a second, on top of the design, so stop it first */
      try { s.flkty.isAnimating = false; s.flkty.velocity = 0; } catch (e) {}
      var st = strip(), holder = s.querySelector('.flickity-slider') || s;
      if (st) {
        var byId = {};
        Array.prototype.forEach.call(s.querySelectorAll('.product-images__slide'), function (e) { byId[sfx(e.id)] = e; });
        Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail'), function (t) { var e = byId[sfx(t.id)]; if (e) holder.appendChild(e); });
        Array.prototype.slice.call(st.querySelectorAll('.product-thumbnail')).forEach(function (t) {
          if (t !== thumb) t.parentNode.replaceChild(t.cloneNode(true), t);
        });
      }
      s.reInit();
      return true;
    }
    function add() {
      var s = sl(); if (!s) return false;
      if (!slide) make();
      var st = strip(); if (st) st.insertBefore(thumb, st.firstChild);
      var holder = s.querySelector('.flickity-slider') || s;
      holder.insertBefore(slide, holder.firstChild);
      slide.classList.add('is-active'); thumb.classList.add('is-active');
      return rebuild();
    }
    /* after the slider is rebuilt, let it re-measure: if the theme rebuilt it a moment earlier (a count or finish change),
       the slides can keep stale positions and a photo ends up drawn over the design */
    function settle(select) {
      var s = sl(); if (!s) return;
      try { s.flkty.resize(); } catch (e) {}
      var i = index();
      if (select !== false && i >= 0) s.flkty.select(i, false, true);
      mark();
    }
    function mark() {
      var s = sl(), st = strip(); if (!s || !st) return;
      var act = st.querySelectorAll('.product-thumbnail.is-active');
      Array.prototype.forEach.call(st.querySelectorAll('.product-thumbnail.is-initial-selected'), function (t) { t.classList.remove('is-initial-selected'); });
      if (act[s.flkty.selectedIndex]) act[s.flkty.selectedIndex].classList.add('is-initial-selected');
    }
    return {
      present: function () { return index() >= 0; },
      /* put the slide in the gallery (if it isn't already), refresh its thumbnail and (unless select is false) bring it into view */
      show: function (select, crop) {
        var rebuilt = false;
        if (index() < 0) { if (!add()) return false; rebuilt = true; }
        else if (!inOrder()) { rebuild(); rebuilt = true; }
        if (rebuilt) { requestAnimationFrame(function () { settle(select); }); [350, 1000].forEach(function (ms) { setTimeout(function () { settle(select); }, ms); }); }
        if (crop) { tctx.clearRect(0, 0, 200, 200); tctx.drawImage(cv, crop[0], crop[1], crop[2], crop[2], 0, 0, 200, 200); }
        var s = sl(), i = index();
        if (select !== false && i >= 0 && s.flkty.selectedIndex !== i) s.flkty.select(i, false, true);
        mark();
        return true;
      },
      tidy: function () {
        if (inOrder()) return;
        var s = sl(), keep = s && s.flkty.selectedElement;
        rebuild();
        s = sl(); if (s && keep) { var i = s.flkty.cells.map(function (c) { return c.element; }).indexOf(keep); if (i >= 0) s.flkty.select(i, false, true); }
        mark();
      },
      box: function () { var s = document.getElementById('Product-Slider'); return s ? s.getBoundingClientRect() : null; }
    };
  })();

  var token = 0, retries = 0;
  function urls(f) { return [CFG.urls.base[f], CFG.urls.letters[f], CFG.urls.plate]; }
  /* draw the design; select = bring the design slide into view; done = called once it is on the page */
  function render(select, done) {
    if (!S.shown || !S.n) return;
    var t = ++token, f = fin(), n = S.n, name = S.name;
    Promise.all(urls(f).map(load)).then(function (im) {
      if (t !== token) return;
      var g = paint(cv.getContext('2d'), f, n, name, im);
      cv.setAttribute('aria-label', 'Preview of your Novelle necklace spelling ' + (name || 'your name'));
      if (gal.show(select, focus(g))) { retries = 0; if (done) done(); }
      else if (retries++ < 20) setTimeout(function () { if (t === token) render(select, done); }, 250);   // the theme's gallery isn't ready yet
    })['catch'](function (e) { if (window.console) console.warn('[luna] preview', e); });
  }
  function warm() { var f = fin(); urls(f).forEach(function (u) { load(u)['catch'](function () {}); }); }

  /* ---------- scrolling ---------- */
  /* how much of the top of the screen the sticky offer strip and header cover */
  function hh() {
    var b = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-header'), function (e) {
      var cs = getComputedStyle(e);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var h = e.getBoundingClientRect().height; if (!h) return;
      b = Math.max(b, (parseFloat(cs.top) || 0) + h);
    });
    return b;
  }
  /* glide up to the design (skipped when it is already on screen, e.g. the sticky gallery on desktop) */
  function toPreview() {
    var r = gal.box(); if (!r) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (r.height && (Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height >= 0.6) return;
    window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - hh() - 10), behavior: 'smooth' });
  }
  function preview() {
    if (!complete()) return;
    if (document.activeElement === inp) inp.blur();   // closes the phone keyboard so the design has the screen
    S.shown = true;
    render(true, function () { setTimeout(toPreview, 60); });
  }

  /* while the design is showing, a count or finish change redraws it instead of jumping to that option's photo */
  function quiet() {
    Array.prototype.forEach.call(document.querySelectorAll('variant-selects, variant-radios'), function (v) {
      if (v.__lunaQuiet || typeof v.updateMedia !== 'function') return;
      v.__lunaQuiet = true;
      var own = v.updateMedia;
      v.updateMedia = function () { if (S.shown && gal.present()) return; return own.apply(this, arguments); };
    });
  }

  /* ---------- events ---------- */
  sel.addEventListener('change', function () {
    var first = !S.n;
    S.n = parseInt(sel.value, 10) || 0;
    if (S.name.length > S.n) S.name = S.name.slice(0, S.n);
    var ph = sel.querySelector('option[value=""]'); if (ph) ph.remove();
    errEl.hidden = true; root.classList.remove('is-invalid'); hint('');
    drawName(); syncProps(); warm();
    syncTheme(S.n);
    if (S.shown) setTimeout(function () { render(false); }, 60);
    if (first) setTimeout(function () {
      var r = step2.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.bottom > vh - 20) window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - hh() - 90), behavior: 'smooth' });
      try { inp.focus({ preventScroll: true }); } catch (e) { inp.focus(); }
    }, 80);
  });
  /* the theme switches the variant (finish or count): redraw the design and the prices */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('fieldset[data-handle="finish"] input')) {
      drawCount(); warm();
      if (S.shown) setTimeout(function () { render(true); }, 60);
      else setTimeout(gal.tidy, 60);
    }
  });

  /* the full name is required before Add to bag / Buy it now */
  function guard(e) {
    var form = productForm(); if (!form) return;
    if (complete()) { unzep(); syncProps(); return; }
    var t = e.target;
    if (e.type === 'submit' && t !== form) return;
    if (e.type === 'click') {
      var b = t.closest && t.closest('button[type="submit"], button[name="add"], .shopify-payment-button__button, .shopify-payment-button [role="button"], [data-add-to-cart]');
      if (!b) return;
      if (!form.contains(b) && b.getAttribute('form') !== form.getAttribute('id')) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    root.classList.add('is-invalid');
    if (!S.n) {
      errEl.textContent = 'Choose how many letters you would like.';
      errEl.hidden = false;
      sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    var left = S.n - S.name.length;
    errEl.textContent = S.name.length ? 'Type ' + left + ' more ' + (left === 1 ? 'letter' : 'letters') + ' to finish your name.' : 'Type your ' + (S.n === 1 ? 'initial' : 'name') + ' to continue.';
    errEl.hidden = false;
    inp.scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { inp.focus({ preventScroll: true }); } catch (x) {}
  }
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);

  /* the theme rebuilds parts of the product area on variant change; keep our inputs and the design slide in place */
  var moT;
  new MutationObserver(function () {
    clearTimeout(moT);
    moT = setTimeout(function () { quiet(); unzep(); syncProps(); if (S.shown && !gal.present()) render(false); }, 50);
  }).observe(document.body, { childList: true, subtree: true });

  quiet(); unzep(); drawCount(); drawName(); syncProps();
  if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 3000 }); else setTimeout(warm, 1500);
})();
